// Single source of truth for the app version shown in the UI.
// Bump by 0.01 on every redeploy (e.g. 1.00 -> 1.01). Major bumps (e.g. 2.00) only on explicit request.
export const APP_VERSION = '2.14';

// Stamped by craco.config.js at build time — in production that is the moment the app was published.
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || null;
export const IS_PREVIEW_BUILD = process.env.REACT_APP_BUILD_MODE !== 'production';

const BERLIN = { timeZone: 'Europe/Berlin' };
export const buildStamp = () => {
  if (IS_PREVIEW_BUILD) return { short: 'preview', long: 'Preview build (dev server) — not the published version' };
  if (!BUILD_TIME) return { short: '', long: '' };
  const d = new Date(BUILD_TIME);
  const short = 'live ' + d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', ...BERLIN }) + ' ' +
    d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', ...BERLIN });
  const long = `Last published ${d.toLocaleDateString('de-DE', { ...BERLIN })}, ${d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', ...BERLIN })} Uhr — fixes reported after this are not live yet`;
  return { short, long };
};
